export const PullQuote = ({ text, testId }) => (
  <blockquote className="pull-quote" data-testid={testId}>
    <p>{text}</p>
  </blockquote>
);
